import { render, staticRenderFns } from "./Batteries.vue?vue&type=template&id=438aa006&scoped=true"
var script = {}
import style0 from "./Batteries.vue?vue&type=style&index=0&id=438aa006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438aa006",
  null
  
)

export default component.exports